var dependedOnViewportAd = require('src/interlock/product/ads/ad-manager/depended-on-viewport-ad.js');

function _subscribeOnViewportChanged() {
    window.googletag.cmd.push(function() {
        window.googletag.pubads().addEventListener('slotVisibilityChanged', function (event) {
            dependedOnViewportAd.slotVisibilityChanged(event);
        });
    });
}

function _subscribe() {
    _subscribeOnViewportChanged();
}

module.exports = {
    subscribe: _subscribe
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-manager/ad-events.js
// module id = 444
// module chunks = 36